/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Tut_Ui_DesignInputs */

const en_wc_tut_ui_design = /** @type {(inputs: Wc_Tut_Ui_DesignInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Design and Layout: themes, margins, orientation, columns, breaks, watermark.`)
};

/**
* | output |
* | --- |
* | "Design and Layout: themes, margins, orientation, columns, breaks, watermark." |
*
* @param {Wc_Tut_Ui_DesignInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_tut_ui_design = /** @type {((inputs?: Wc_Tut_Ui_DesignInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Tut_Ui_DesignInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_tut_ui_design(inputs)
});
export { wc_tut_ui_design as "wc.tut.ui.design" }